import { KnowledgeProduct } from '@/models/user';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'umi';

export default function useKnowledgeProduct() {
  const [loading, setLoading] = useState<boolean>(false);
  const data: KnowledgeProduct[] = useSelector((state: any) => state.user.productNames);
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      await dispatch({ type: 'user/getKnowledgeProduct' });
      setLoading(false);
    }
    if (data.length === 0) {
      fetchData();
    }
  }, []);

  return { data, loading }
}